import { defineMessages } from 'react-intl';

// components
import { SbRespRefineMenuFilterPrice } from './SbRespRefineMenuFilterPrice';
import { SbRespRefineMenuFilterCategory } from './SbRespRefineMenuFilterCategory';
import { SbRespRefineMenuFilterStoneCut } from './SbRespRefineMenuFilterStoneCut';
import { SbRespRefineMenuFilterDimensions } from './SbRespRefineMenuFilterDimensions';
import { SbRespRefineMenuFilterCaratWeight } from './SbRespRefineMenuFilterCaratWeight';
import { SbRespRefineMenuFilterDeliveryOptions } from './SbRespRefineMenuFilterDeliveryOptions';
import { sbSharedRefineMenuFiltersMap } from '../../SbSharedRefineMenu/SbSharedRefineMenuFilters/sbSharedRefineMenuFiltersMap';

const titleOverrides = defineMessages({
    dimensions: {
        id: 'sb.SbRespRefineMenuFilterDimension.title',
        defaultMessage: 'Dimensions',
    },
    location: {
        id: 'sb.SbRespRefineMenuFilterDeliveryOptions.title',
        defaultMessage: 'Shipping Options',
    },
});

export const sbRespRefineMenuFiltersMap = Object.assign({}, sbSharedRefineMenuFiltersMap, {
    categoryL1: {
        component: SbRespRefineMenuFilterCategory,
    },
    'carat-weight': {
        component: SbRespRefineMenuFilterCaratWeight,
    },
    height: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    width: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    length: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    depth: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    price: {
        component: SbRespRefineMenuFilterPrice,
    },
    priceTrade: {
        component: SbRespRefineMenuFilterPrice,
        showTradeOnboardingCoachmark: true,
    },
    'stone-cut': {
        component: SbRespRefineMenuFilterStoneCut,
    },
    latest: {
        component: null,
        isBatchAppliedFilter: true,
    },
    location: {
        component: SbRespRefineMenuFilterDeliveryOptions,
        title: titleOverrides.location,
        showFreeShippingCoachmark: true,
    },
    sale: {
        component: null,
        isBatchAppliedFilter: true,
    },
    customizable: {
        component: null,
        isBatchAppliedFilter: true,
    },
    'net-price': {
        component: null,
        isBatchAppliedFilter: true,
    },
    returnable: {
        component: null,
        isBatchAppliedFilter: true,
    },
    recognized: {
        component: null,
        isBatchAppliedFilter: true,
    },
    topSeller: {
        component: null,
        isBatchAppliedFilter: true,
    },
    isSellerStrategicPartner: {
        component: null,
        isBatchAppliedFilter: true,
    },
    view: {
        component: null,
        isBatchAppliedFilter: true,
    },
});

export const getValidRespAppliedFilters = function({ appliedFilters = [] }) {
    return appliedFilters.filter(filter => filter.canBeDismissed);
};

export const isBatchAppliedFilter = filterName =>
    sbRespRefineMenuFiltersMap[filterName] &&
    !!sbRespRefineMenuFiltersMap[filterName].isBatchAppliedFilter;
